module.exports = __webpack_public_path__ + "static/media/e52360e2-f859-45dd-93aa-6ccbb1e0f6a7.4591411a.JPG";